import { useCallback } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SnackbarContainer } from 'components/standalone';
import { extractErrorMessage } from 'utils';
import { PermissionsProvider } from 'providers/permissionsProvider';
import { AppRole } from 'providers/roles';
import {
  RegionContainer,
  RegionFormValues,
} from '../containers/useRegionContainer';
import { RegionForm } from '../components/RegionForm';

const RegionCreateInner = () => {
  const classes = useStyles();
  const history = useHistory();
  const { notify } = SnackbarContainer.useContainer();
  const { formLoading, createRegion } = RegionContainer.useContainer();
  const { hasRole } = PermissionsProvider.useContainer();

  if (!hasRole(AppRole.SuperAdmin)) {
    return <Redirect to="/region" />;
  }

  const handleSubmit = useCallback(
    async (values: RegionFormValues) => {
      try {
        const region = await createRegion(values);
        notify('Element created');
        history.push(`/region/${region.id}`);
      } catch (error: unknown) {
        console.error('Region create failed:', error);
        notify(
          extractErrorMessage(error, 'Error while creating the region'),
          'error',
        );
      }
    },
    [createRegion, history, notify],
  );

  const handleGoBack = useCallback(() => {
    history.push('/region');
  }, [history]);

  return (
    <Box className={classes.createBox}>
      <Box className={classes.formContainer}>
        <RegionForm
          mode="create"
          onSubmit={handleSubmit}
          loading={formLoading}
          onGoBack={handleGoBack}
        />
      </Box>
    </Box>
  );
};

export const RegionsCreate = () => {
  return (
    <RegionContainer.Provider>
      <RegionCreateInner />
    </RegionContainer.Provider>
  );
};

const useStyles = makeStyles(theme => ({
  createBox: {
    maxWidth: '1500px',
  },
  formContainer: {
    position: 'relative',
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.background.paper,
  },
}));

export default RegionsCreate;
